import axios from "axios";

import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import { TwPopover, TwRating } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { getUrlForEvent } from "../../utils/confighelpers";
import { useTranslation } from "react-i18next";

export default function EventTile({
  imgSrc,
  name,
  rating,
  bookingRevenue,
  seatsBooked,
  popover,
  popoverLine,
  insideDetailView,
  handleSessionClick,
  classDetail,
  reloadData,
}) {

  const { t, i18n } = useTranslation();
  const [userToken] = useLocalStorage("userToken");

  const updateStatus = async (eventData, status) => {

    const config = {
      method: "post",
      url: `${getUrlForEvent()}updatestatus/${eventData.id}`,
      headers: {
        "x-access-token": userToken,
      },
      data: { status }
    };
    const request = await axios(config);
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        reloadData();
      }
    }
  };


  return (
    <div
      className={`${"my-3"} p-4 flex flex-row items-center gap-4 ${insideDetailView ? "cursor-pointer" : ""
        } bg-white hover:bg-[#e1e1e1] shadow-md border border-bright-gray rounded-2xl`}
    >
      <div className="flex flex-row items-top gap-4 grow" onClick={() => { handleSessionClick(); }}>
        <div
          className=""
        >
          <img
            className={`${"w-[127.28px] max-w-[127.28px] h-[101px] rounded-xl"
              } object-fill`}
            src={imgSrc}
            alt={"session img"}
          />
        </div>
        <div className={`flex item-top grow`}>
          <div className={`flex flex-col item-center w-full gap-2`}>
            <h3
              className={`font-bold text-base`}
            >
              {name}
            </h3>
            <div className={"flex flex-row items-center gap-2"}>
              <TwRating
                rating={rating}
              />
            </div>
            <div className={"flex flex-row items-center gap-2"}>
              {/* <Box
                className={`p-1 px-2 mt-2 text-xs rounded-full`}
                sx={{ ...(classDetail?.isPublic ? statusColors[classDetail.isPublic.toString().toLowerCase()] : statusColors["false"]) }}
              >
                {classDetail?.isPublic ? "Published" : "Draft"}
              </Box> */}
            </div>
          </div>
        </div>
        <div className={"flex flex-col items-center"}>
          <div className={"flex flex-col items-center align-middle"}>
            <div
              className={"text-light-primary h-[40px] mt-5"}
            >
              <div
                className={
                  "w-[35px] h-[35px] flex justify-center items-center bg-light-primary rounded-full"
                }
              >
                <p className={"font-bold text-white text-[10px]"}>
                  {Number(seatsBooked)}
                </p>
              </div>
            </div>
            {/* <h3
              className={
                "text-light-primary font-bold text-sm sm:text-sm md:text-sm lg:text-sm"
              }
            >
              {seatsBooked}/{totalSeats}
            </h3> */}
            <p className={"text-granite-gray text-xs text-center"}>
              {t("myEvents.ticketsSold")}
            </p>
          </div>
        </div>
      </div>
      {popover && (
        <>
          <div className={"flex flex-col items-center ml-auto"}>

            <TwPopover
              buttonClassName={""}
              buttonContent={(<EllipsisVerticalIcon aria-hidden="true" className="size-5" />)}
            >
              <div className={"flex flex-col divide-y divide-gray-200"}>
                <button
                  className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}

                  onClick={() => {
                    handleSessionClick();
                    // handleDateTimeModalOpen();
                  }}
                >
                  {t("inputFieldsTitle.view")}
                </button>
                {/* <button
                    className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}

                    onClick={() => {
                      updateStatus(classDetail, classDetail?.isPublic ? "Draft" : "Published");
                    }}
                  >
                    Mark As {classDetail?.isPublic ? "Draft" : "Published"}
                  </button> */}
              </div>
            </TwPopover>
          </div>
        </>
      )}
    </div>
  );
}
